import { render, staticRenderFns } from "./PersetujuanTransfusiDarahTabPage.vue?vue&type=template&id=fbfc7eba&"
import script from "./PersetujuanTransfusiDarahTabPage.vue?vue&type=script&lang=ts&"
export * from "./PersetujuanTransfusiDarahTabPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
